/**
 * Admin SMS test API — POST /api/admin/sms/test.
 *
 * Backed by sm4rt-api, which forwards to the comms service (sm4rt_emailer →
 * TouchSMS). Admin role required. Validation (AU mobile, GSM-7, part counting)
 * happens server-side; the error string is written for an operator to read, so
 * it is surfaced verbatim.
 */

const API_URL = '/api/admin/sms/test';

export interface SendTestSmsRequest {
  /** Destination in any common AU format — the server normalises to E.164. */
  to: string;
  body: string;
  /** Validate and cost the message without delivering it. */
  dryRun?: boolean;
}

export interface SendTestSmsResult {
  sent: boolean;
  /** Normalised destination, E.164. */
  to: string;
  from?: string;
  provider?: string;
  reference?: string | null;
  dryRun: boolean;
  characters?: number;
  /** SMS parts — one credit each. */
  parts?: number;
  credits?: number;
  creditBalance?: number;
}

export async function sendTestSms(
  request: SendTestSmsRequest,
  signal?: AbortSignal,
): Promise<SendTestSmsResult> {
  const response = await fetch(API_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(request),
    signal,
  });

  if (!response.ok) {
    let message = `SMS send failed (${response.status} ${response.statusText})`;
    try {
      const data = await response.json();
      if (data?.error) message = data.error;
    } catch {
      // Non-JSON error body — keep the status-based message.
    }
    throw new Error(message);
  }

  return response.json();
}
